export default "__VITE_ASSET__yRibWOZ5__"